import { getIsSLAResolved } from 'conversations-internal-schema/sla/operators/getIsSLAResolved';
import { getSLAsFromTicket } from './getSLAsFromTicket';
export const getActiveSLAFromTicket = ticket => {
  const slas = getSLAsFromTicket(ticket);
  const values = Object.values(slas).sort((SLA1, SLA2) => SLA1.priority - SLA2.priority);
  const activeSLA = values.find(sla => !getIsSLAResolved(sla.status));
  return activeSLA || null;
};